const haveWindow = typeof window !== `undefined`;

let logclient;

const getLogClient = async () => {
  if (!logclient) {
    logclient = await import("@classdojo/log-client");
  }
  return logclient;
};

let events = [];

const init = async (args) => {
  if (!haveWindow) return;
  return (await getLogClient()).init(args);
};

const logEvent = async (event) => {
  if (!haveWindow) return;
  if (typeof event === "string") {
    events.push({
      eventName: event,
    });
  } else {
    events.push(event);
  }
  return (await getLogClient()).logEvent(event);
};

const setEntityId = async (args) => {
  if (!haveWindow) return;
  return (await getLogClient()).setEntityId(args);
};

const setFeatureSetId = async (args) => {
  if (!haveWindow) return;
  return (await getLogClient()).setFeatureSetId(args);
};

const getSessionId = async () => {
  if (!haveWindow) return;
  return (await getLogClient()).getSessionId();
};

const __flush = () => {
  events = [];
};

const getEventNames = () => {
  return events.map(function (e) {
    return e.eventName;
  });
};

const eventsOccurredInOrder = (eventNames) => {
  let e, i, idx, len, logged;
  logged = getEventNames();
  for (i = 0, len = eventNames.length; i < len; i++) {
    e = eventNames[i];
    idx = logged.indexOf(e);
    if (idx === -1) {
      return false;
    }
    logged = logged.slice(idx + 1);
  }
  return true;
};

const eventsOccurredInExactOrder = (eventNames) => {
  let i, item, j, len;
  const logged = getEventNames();
  const idx = logged.indexOf(eventNames[0]);
  if (idx === -1) {
    return false;
  }
  const section = logged.slice(idx, idx + eventNames.length);
  for (i = j = 0, len = eventNames.length; j < len; i = ++j) {
    item = eventNames[i];
    if (section[i] !== item) {
      return false;
    }
  }
  return true;
};

const incrementMetric = async (metricName) => {
  if (!haveWindow) return;
  return (await getLogClient()).sendMetrics([
    {
      type: "increment",
      value: 1,
      metricName: metricName,
    },
  ]);
};

const _logException = haveWindow
  ? (async () => {
      return (await getLogClient()).logException;
    })()
  : Promise.resolve((...args) => {
      console.error("LOG_EXCEPTION_NO_WINDOW:", ...args);
    });

const logException = async (...args) => {
  const f = await _logException;
  f(...args);
};

// give this a unique name from the underlying logClient.logException so autocomplete/autoimport
// works more accurately
const sendException = logException;

export {
  init,
  logEvent,
  incrementMetric,
  setEntityId,
  getSessionId,
  __flush,
  eventsOccurredInOrder,
  eventsOccurredInExactOrder,
  getEventNames,
  logException,
  sendException,
  setFeatureSetId,
};
